<h2 mat-dialog-title>Confirmação de senha</h2>
<div mat-dialog-content class="auth-dialog-content">
  <p class="auth-dialog-message">{{ message }}</p>

  <div *ngIf="errorMessage" class="alert alert-danger">
    {{ errorMessage }}
  </div>

  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Senha</mat-label>
    <input
      matInput
      type="password"
      [(ngModel)]="password"
      (keyup.enter)="confirm()"
      autocomplete="current-password"
      [disabled]="loading" />
  </mat-form-field>
</div>
<div mat-dialog-actions class="auth-dialog-actions">
  <button mat-button type="button" (click)="cancel()" [disabled]="loading">Cancelar</button>
  <button
    mat-flat-button
    color="primary"
    type="button"
    class="submit-button"
    (click)="confirm()"
    [disabled]="loading || !password.trim()">
    Confirmar
  </button>
</div>
